module.exports = __webpack_public_path__ + "static/media/reformer10.95d854dc.jpg";